import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { KeyboardService, KeyboardShortcut } from '../../../core/services/keyboard.service';

@Component({
  selector: 'app-keyboard-shortcuts-help',
  templateUrl: './keyboard-shortcuts-help.component.html',
  styleUrls: ['./keyboard-shortcuts-help.component.scss']
})
export class KeyboardShortcutsHelpComponent {
  playbackShortcuts: KeyboardShortcut[];
  volumeShortcuts: KeyboardShortcut[];
  seekingShortcuts: KeyboardShortcut[];
  mediaKeyShortcuts: KeyboardShortcut[];

  constructor(
    private keyboardService: KeyboardService,
    private dialogRef: MatDialogRef<KeyboardShortcutsHelpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.playbackShortcuts = this.keyboardService.getPlaybackShortcuts();
    this.volumeShortcuts = this.keyboardService.getVolumeShortcuts();
    this.seekingShortcuts = this.keyboardService.getSeekingShortcuts();
    this.mediaKeyShortcuts = this.keyboardService.getMediaKeyShortcuts();
  }

  formatShortcut(shortcut: KeyboardShortcut): string {
    return this.keyboardService.formatShortcut(shortcut);
  }

  close(): void {
    this.dialogRef.close();
  }
}